// DO NOT EDIT -- generated from fs/services/alexa/wayfinder.proto

import { QueryCacheOptions } from './search_service_types.proto';
import { SortOrder } from './searchies.proto';
import * as protobuf from '../../../google/protobuf';
import * as segment from '../../api/segment';

export namespace WayfinderService {

  export const ComputeVisitsEndpoint = "/grpc/alexa.WayfinderService/ComputeVisits";
  /**
   * ComputeVisits computes aggregate visit statistics for the supplied org and time range.
   * Expected error codes:
   * NotFound: If Org is not found.
   */
  export function ComputeVisits(sender: (req: ComputeVisitsRequest, endpoint: string) => Promise<ComputeVisitsResponse>, req: ComputeVisitsRequest): { promise: () => Promise<ComputeVisitsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ComputeVisitsEndpoint),
      endpoint: ComputeVisitsEndpoint
    };
  }

  export const ComputeUsageEndpoint = "/grpc/alexa.WayfinderService/ComputeUsage";
  /**
   * ComputeUsage computes aggregate app and user statistics for the supplied org and time range.
   * Expected error codes:
   * NotFound: If Org is not found.
   */
  export function ComputeUsage(sender: (req: ComputeUsageRequest, endpoint: string) => Promise<ComputeUsageResponse>, req: ComputeUsageRequest): { promise: () => Promise<ComputeUsageResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ComputeUsageEndpoint),
      endpoint: ComputeUsageEndpoint
    };
  }

  export const ComputeUserAppsEndpoint = "/grpc/alexa.WayfinderService/ComputeUserApps";
  /**
   * ComputeUserApps computes active time and page counts of the top apps of a given user.
   * Expected error codes:
   * NotFound: If Org is not found.
   */
  export function ComputeUserApps(sender: (req: ComputeUserAppsRequest, endpoint: string) => Promise<ComputeUserAppsResponse>, req: ComputeUserAppsRequest): { promise: () => Promise<ComputeUserAppsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ComputeUserAppsEndpoint),
      endpoint: ComputeUserAppsEndpoint
    };
  }

  export const ComputeAppEngagementEndpoint = "/grpc/alexa.WayfinderService/ComputeAppEngagement";
  /**
   * ComputeAppEngagement computes percentiles of active time by user for a given app.
   * Expected error codes:
   * NotFound: If Org is not found.
   */
  export function ComputeAppEngagement(sender: (req: ComputeAppEngagementRequest, endpoint: string) => Promise<ComputeAppEngagementResponse>, req: ComputeAppEngagementRequest): { promise: () => Promise<ComputeAppEngagementResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ComputeAppEngagementEndpoint),
      endpoint: ComputeAppEngagementEndpoint
    };
  }
}

export namespace WayfinderServicePublic {

  export const ComputeAppUsageEndpoint = "/grpc/alexa.WayfinderServicePublic/ComputeAppUsage";
  /**
   * ComputeAppUsage computes active time and page counts of the top user of a given app.
   * Expected error codes:
   * NotFound: If Org is not found.
   */
  export function ComputeAppUsage(sender: (req: ComputeAppUsageRequest, endpoint: string) => Promise<ComputeAppUsageResponse>, req: ComputeAppUsageRequest): { promise: () => Promise<ComputeAppUsageResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ComputeAppUsageEndpoint),
      endpoint: ComputeAppUsageEndpoint
    };
  }

  export const ComputeAppUsersEndpoint = "/grpc/alexa.WayfinderServicePublic/ComputeAppUsers";
  /**
   * ComputeAppUsers computes user-level active time, page counts, and session details of a given app.
   * Expected error codes:
   * NotFound: If Org is not found.
   */
  export function ComputeAppUsers(sender: (req: ComputeAppUsersRequest, endpoint: string) => Promise<ComputeAppUsersResponse>, req: ComputeAppUsersRequest): { promise: () => Promise<ComputeAppUsersResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ComputeAppUsersEndpoint),
      endpoint: ComputeAppUsersEndpoint
    };
  }

  export const ComputeVersionMetricsEndpoint = "/grpc/alexa.WayfinderServicePublic/ComputeVersionMetrics";
  /**
   * ComputeVersionMetrics aggregates data about installed Wayfinder extensions in the wild.
   * This information is used by Wayfinder admins to help understand how many devices have
   * the browser extension installed and with what version.
   */
  export function ComputeVersionMetrics(sender: (req: ComputeVersionMetricsRequest, endpoint: string) => Promise<ComputeVersionMetricsResponse>, req: ComputeVersionMetricsRequest): { promise: () => Promise<ComputeVersionMetricsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ComputeVersionMetricsEndpoint),
      endpoint: ComputeVersionMetricsEndpoint
    };
  }

  export const QueryUserPagesEndpoint = "/grpc/alexa.WayfinderServicePublic/QueryUserPages";
  export function QueryUserPages(sender: (req: QueryUserPagesRequest, endpoint: string) => Promise<QueryUserPagesResponse>, req: QueryUserPagesRequest): { promise: () => Promise<QueryUserPagesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, QueryUserPagesEndpoint),
      endpoint: QueryUserPagesEndpoint
    };
  }
}

export interface ComputeUsageRequest {
  /** The org for which visit data will be aggregated. */
  orgId: string;
  /**
   * The time window for which solr data will be queried.
   * Optional: will compute the default time range if absent.
   */
  timeRange: segment.TimeRange | null;
  /**
   * CacheOptions is options for the query cache. Default will be
   * provided by the application if any fields are omitted.
   * Defaults are set based on the time interval of the computation.
   */
  cacheOptions: QueryCacheOptions | null;
}

export interface ComputeUsageResponse {
  /** Count of captured apps in this time range. */
  appCount: protobuf.int64;
  /** Count of captured users (over every app) in this time range. */
  userCount: protobuf.int64;
  /** Count of captured pages (over every app) in this time range. */
  pageCount: protobuf.int64;
  /** ComputedAt determines when the data was computed. */
  computedAt: protobuf.timestamp | null;
}

export interface ComputeVisitsRequest {
  /** The org for which visit data will be aggregated. */
  orgId: string;
  /**
   * The time window for which solr data will be queried.
   * Optional: will compute the default time range if absent.
   */
  timeRange: segment.TimeRange | null;
  /**
   * CacheOptions is options for the query cache. Default will be
   * provided by the application if any fields are omitted.
   * Defaults are set based on the time interval of the computation.
   */
  cacheOptions: QueryCacheOptions | null;
}

export interface ComputeVisitsResponse {
  /** the total counts for the entire query, including filtered/excluded results */
  total: VisitAggregation | null;
  /** the set of aggregations that meet the filtering criteria */
  aggs: VisitAggregation[];
  /** ComputedAt determines when the data was computed. */
  computedAt: protobuf.timestamp | null;
}

export interface ComputeVersionMetricsRequest {
  /** The org for which visit data will be aggregated. */
  orgId: string;
  /**
   * CacheOptions is options for the query cache. Default will be
   * provided by the application if any fields are omitted.
   * Defaults are set based on the time interval of the computation.
   */
  cacheOptions: QueryCacheOptions | null;
}

export interface ComputeVersionMetricsResponse {
  /** Versions are returned sorted newer -> older. */
  versions: VersionReport[];
  /** ComputedAt determines when the data was computed. */
  computedAt: protobuf.timestamp | null;
}

export interface VersionReport {
  version: string;
  deviceCount: protobuf.int64;
}

/** VisitAggregation represents a single row in the compute visits response. */
export interface VisitAggregation {
  /** the domain or a glob domain, e.g. `app.fullstory.com` or `*.fullstory.com` */
  domain: string;
  /** the number of unique devices seen in this timeframe */
  deviceCount: protobuf.int64;
  /** the raw number of of visits seen in this timeframe */
  visitCount: protobuf.int64;
}

export interface ComputeAppUsageRequest {
  /** The org for which visit data will be aggregated. */
  orgId: string;
  /** query pages by named App */
  appId: string;
  /**
   * The time window for which solr data will be queried.
   * Optional: will compute the default time range if absent.
   */
  timeRange: segment.TimeRange | null;
  /**
   * CacheOptions is options for the query cache. Default will be
   * provided by the application if any fields are omitted.
   * Defaults are set based on the time interval of the computation.
   */
  cacheOptions: QueryCacheOptions | null;
}

export interface ComputeAppUsageResponse {
  /** the total number of users and sessions, including filtered results */
  total: AppUserAggregate | null;
  /** the user wth the most signifcant activity for this app */
  topUser: AppUserActivity | null;
  /** ComputedAt determines when the data was computed. */
  computedAt: protobuf.timestamp | null;
}

export enum SortColumn {
  INVALID_COLUMN = 0,
  EMAIL = 1,
  ACTIVE_TIME = 2,
  LAST_SEEN = 3
}

export interface ComputeAppUsersRequest {
  /** The org for which visit data will be aggregated. */
  orgId: string;
  /** query pages by named App */
  appId: string;
  /** the offset to start from */
  start: number;
  /** the maximum number of results to return */
  limit: number;
  /** the search term to filter users by */
  searchTerm: string;
  /** the column to sort by. Valid values are: "active_time", "last_seen" */
  sortColumn: SortColumn;
  /** the column's order to sort by */
  sortOrder: SortOrder;
  /**
   * The time window for which solr data will be queried.
   * Optional: will compute the default time range if absent.
   */
  timeRange: segment.TimeRange | null;
  /**
   * CacheOptions is options for the query cache. Default will be
   * provided by the application if any fields are omitted.
   * Defaults are set based on the time interval of the computation.
   */
  cacheOptions: QueryCacheOptions | null;
}

export interface ComputeAppUsersResponse {
  /** the total number of users */
  numUsers: protobuf.int64;
  /** the list of users with significant activity within this app; sorted by most active time to least */
  users: AppUserActivity[];
  /** ComputedAt determines when the data was computed. */
  computedAt: protobuf.timestamp | null;
}

/** AppUserAggregate represents number of users, sessions, active time, and pages count for a given app. */
export interface AppUserAggregate {
  activeMillis: protobuf.int64;
  pagesCount: protobuf.int64;
  numUsers: protobuf.int64;
}

/** AppUserActivity represents a single row in the compute app users response. */
export interface AppUserActivity {
  /** the individual ID of this user */
  indvId: protobuf.int64;
  /** the user's display name; may be anonymous. If the display name is "User XXXX", should display email instead. */
  displayName: string;
  /** the user's email */
  email: string;
  /** the number of active millis for this user on this app */
  activeMillis: protobuf.int64;
  /** the raw number of page visits for this user on this app */
  pagesCount: protobuf.int64;
  /** the user's last activity details for this app */
  lastPageStart: protobuf.timestamp | null;
  lastPageDuration: protobuf.int64;
  lastPageActiveDuration: protobuf.int64;
  lastPageInactiveDuration: protobuf.int64;
  lastPageNumEvents: protobuf.int64;
  lastPageUrl: string;
  lastSessionId: string;
  lastPageAppId: string;
  lastSeen: protobuf.timestamp | null;
}

export interface ComputeUserAppsRequest {
  /** The org for which visit data will be aggregated. */
  orgId: string;
  /** query pages by named user email */
  email: string;
  /**
   * The time window for which solr data will be queried.
   * Optional: will compute the default time range if absent.
   */
  timeRange: segment.TimeRange | null;
  /**
   * CacheOptions is options for the query cache. Default will be
   * provided by the application if any fields are omitted.
   * Defaults are set based on the time interval of the computation.
   */
  cacheOptions: QueryCacheOptions | null;
}

export interface ComputeUserAppsResponse {
  /** the total counts for the entire query, including filtered/excluded results */
  total: UserAppActivity | null;
  /** the list of users with significant activity within this app; sorted by most active time to least */
  apps: UserAppActivity[];
  /** ComputedAt determines when the data was computed. */
  computedAt: protobuf.timestamp | null;
}

/** UserAppActivity represents a single row in the compute user apps response. */
export interface UserAppActivity {
  /** the app id containing activity */
  appId: string;
  /** the number of active millis for this user on this app */
  activeMillis: protobuf.int64;
  /** the raw number of page visits for this user on this app */
  pagesCount: protobuf.int64;
  lastSeen: protobuf.timestamp | null;
}

export interface ComputeAppEngagementRequest {
  /** The org for which visit data will be aggregated. */
  orgId: string;
  /** query pages by named App */
  appId: string;
  /**
   * The time window for which solr data will be queried.
   * Optional: will compute the default time range if absent.
   */
  timeRange: segment.TimeRange | null;
  /**
   * Users must have at least this much active time within
   * the time_range to be deemed 'engaged'.
   */
  activeThreshold: protobuf.duration | null;
  /**
   * CacheOptions is options for the query cache. Default will be
   * provided by the application if any fields are omitted.
   * Defaults are set based on the time interval of the computation.
   */
  cacheOptions: QueryCacheOptions | null;
}

export interface ComputeAppEngagementResponse {
  data: EngagementSnapshot | null;
  /** ComputedAt determines when the data was computed. */
  computedAt: protobuf.timestamp | null;
}

export interface EngagementSnapshot {
  startTime: protobuf.timestamp | null;
  endTime: protobuf.timestamp | null;
  engagedCount: protobuf.int64;
  totalCount: protobuf.int64;
}

export interface QueryUserPagesRequest {
  /** The org for the user. */
  orgId: string;
  /** Query pages by named user email */
  email: string;
  /**
   * If set, include _only_ these app ids.
   * If unset, all app ids will be included by default.
   */
  includeAppId: string[];
  /** Exclude these app ids. */
  excludeAppId: string[];
  /**
   * The time window for which solr data will be queried.
   * Optional: will compute the default time range if absent.
   */
  timeRange: segment.TimeRange | null;
  /**
   * CacheOptions is options for the query cache. Default will be
   * provided by the application if any fields are omitted.
   * Defaults are set based on the time interval of the computation.
   */
  cacheOptions: QueryCacheOptions | null;
}

export interface QueryUserPagesResponse {
  /** Result pages. */
  pages: PageMatch[];
  /** Custom events */
  events: EventMatch[];
  /** ComputedAt determines when the data was computed. */
  computedAt: protobuf.timestamp | null;
}

export interface EventMatch {
  /** e.g. scottb@fullstory.com */
  email: string;
  /** e.g. Scott B */
  displayName: string;
  /** e.g. github */
  appId: string;
  /** e.g. github */
  vendorId: string;
  /** e.g. 754879372491809224 */
  indvId: protobuf.int64;
  /** e.g. 1690976061793090565 */
  userId: protobuf.int64;
  /** e.g. 3184397071672566748 */
  sessionId: protobuf.int64;
  /** e.g. 1113640304149895475 */
  pageId: protobuf.int64;
  /** e.g. 2024-05-09T22:07:14.233Z */
  sessionStart: protobuf.timestamp | null;
  /** e.g. 2024-05-09T22:07:14.233Z */
  pageStart: protobuf.timestamp | null;
  /** e.g. Feedback Submitted */
  eventName: string;
  /** e.g. 2024-05-09T22:09:14.000Z */
  eventStart: protobuf.timestamp | null;
  /** e.g. 9654 */
  eventPageOffset: number;
  eventProperties: protobuf.Struct | null;
  /** e.g. Chrome */
  pageBrowser: segment.Browser;
  /** e.g. Desktop */
  pageDevice: segment.Device;
  /** e.g. OS X */
  pageOperatingSystem: segment.OS;
  /** e.g. Web */
  pagePlatform: segment.Platform;
  /** e.g. https://github.com/cowpaths/mn/compare/scottb/domcfg */
  pageUrl: string;
  /** e.g. github.com */
  pageUrlHost: string;
}

export interface PageMatch {
  /** e.g. scottb@fullstory.com */
  email: string;
  /** e.g. Scott B */
  displayName: string;
  /** e.g. github */
  appId: string;
  /** e.g. github */
  vendorId: string;
  /** e.g. 754879372491809224 */
  indvId: protobuf.int64;
  /** e.g. 1690976061793090565 */
  userId: protobuf.int64;
  /** e.g. 3184397071672566748 */
  sessionId: protobuf.int64;
  /** e.g. 1113640304149895475 */
  pageId: protobuf.int64;
  /** e.g. 2024-05-09T22:07:14.233Z */
  sessionStart: protobuf.timestamp | null;
  /** e.g. 2024-05-09T22:07:14.233Z */
  pageStart: protobuf.timestamp | null;
  /** e.g. 15 */
  pageNumEvents: number;
  /** e.g. 25572 */
  pageDurationMillis: protobuf.int64;
  /** e.g. 11737 */
  pageActiveDurationMillis: protobuf.int64;
  /** e.g. Chrome */
  pageBrowser: segment.Browser;
  /** e.g. Desktop */
  pageDevice: segment.Device;
  /** e.g. OS X */
  pageOperatingSystem: segment.OS;
  /** e.g. Web */
  pagePlatform: segment.Platform;
  /** e.g. https://github.com/cowpaths/mn/compare/scottb/domcfg */
  pageUrl: string;
  /** e.g. github.com */
  pageUrlHost: string;
}
